export const translations = {
  da: {
    // Navbar
    nav: {
      home: 'Hjem',
      about: 'Om Mig',
      haircuts: 'Klipning',
      coloring: 'Farvning',
      treatments: 'Behandlinger',
      prices: 'Priser',
      contact: 'Kontakt',
      bookNow: 'Book Nu'
    },
    // Hero
    hero: {
      tagline: 'Hvor smukt hår begynder',
      description: 'Med over syv års professionel erfaring stræber jeg efter at fremhæve din selvtillid og skønhed. Jeg er specialiseret i skræddersyede klipninger, avancerede farveteknikker og eksklusive behandlinger. Alle mine services tilpasses dine individuelle behov, så du får præcis det resultat, der passer til dig.',
      bookNow: 'Book Nu',
      contactUs: 'Kontakt Mig'
    },
    // Services
    services: {
      title: 'Mine Services',
      subtitle: 'Udforsk mit udvalg af specialiserede hårbehandlinger',
      haircuts: {
        title: 'Klipning',
        subtitle: 'Skræddersyet til perfektion',
        description: 'Hver klipning er tilpasset til din ansigtsforme, hårstruktur og personlige stil. Uanset om du leder efter en klassisk klipning eller noget moderne, skaber jeg et look, der fremhæver dine bedste træk.',
        features: [
          'Konsultation',
          'Præcisionsklipningsteknikker',
          'Styling og finish',
          'Personlige hårplejeanbefalinger'
        ]
      },
      coloring: {
        title: 'Hårfarvning',
        subtitle: 'Avancerede teknikker',
        description: 'Specialiseret i moderne farvningsmetoder, der giver smukke, naturligt udseende resultater. Fra subtile nuancer til markante transformationer bruger jeg kvalitetsprodukter for at opnå den perfekte farve.',
        servicesOffered: 'Farvning',
        features: [
          'Airtouch',
          'Total Blond',
          'Babylights',
          'Brazilian Blonde',
          'Balayage',
          'Helfarvning',
          'Farvekorrektion'
        ]
      },
      treatments: {
        title: 'Hårbehandlinger',
        subtitle: 'Premium pleje',
        description: 'Genskab og forny dit hår med eksklusive behandlinger fra verdenskendte brands. Hver behandling udvælges specielt til dit hår for at give de bedst mulige resultater.',
        treatmentsOffered: 'Behandlinger',
        features: [
          'Nashi Argan treatment',
          'Davines treatment',
          'Schwarzkopf professional system',
          'Deep conditioning',
          'Scalp detox treatment'
        ]
      },
      learnMore: 'Læs Mere',
      aboutService: 'Om Denne Service',
      whatsIncluded: 'Hvad er Inkluderet'
    },
    // Gallery
    gallery: {
      title: 'Mine Resultater',
      subtitle: 'Før og efter - mine kunder',
      colorTransformations: 'Farvetransformationer',
      haircutExamples: 'Klipningseksempler'
    },
    // Why Choose
    whyChoose: {
      title: 'Hvorfor Vælge Madame Cristina',
      experience: {
        title: '+7 Års Erfaring',
        description: 'Professionel ekspertise du kan stole på'
      },
      trends: {
        title: 'Nyeste Trends',
        description: 'Løbende opdateret gennem kurser og masterclasses'
      },
      care: {
        title: 'Personlig Pleje',
        description: 'Hver ydelse tilpasset dine behov'
      }
    },
    // CTA
    cta: {
      ready: 'Klar til en forandring?',
      book: 'Book din tid i dag og oplev forskellen',
      bookAppointment: 'Book Tid',
      readyForService: 'Klar til',
      question: 'Har du spørgsmål om mine ydelser eller priser? Du er velkommen til at kontakte mig eller book tid online.'
    },
    // Prices
    prices: {
      title: 'Prisliste',
      subtitle: 'Transparent prissætning for alle mine services. Alle priser i DKK.',
      haircut: 'Dame Klip',
      haircutNote: '(inkl. vask og føn)',
      color: 'Farve',
      colorNote: '(inkl. vask og føn)',
      styling: 'Styling',
      stylingNote: '(inkl. vask og føn)',
      blonde: 'Blonde',
      blondeNote: '(inkl. vask og føn)',
      treatments: 'Treatments',
      treatmentsNote: '(inkl. vask og føn)',
      popular: 'Populær',
      specialOffers: 'Særlige Tilbud',
      saveWith: 'Spar med mine kombinerede behandlingspakker',
      note: '* Priserne kan variere afhængigt af hårlængde, tykkelse og tilstand. Den endelige pris bekræftes under konsultation.',
      items: {
        haircut: {
          short: 'Kort',
          long: 'Langt',
          curlCut: 'Curl cut',
          bangs: 'Pandehår klip (uden vask)'
        },
        color: {
          roots: 'Bundfarve',
          toner: 'Toner',
          allOverColor: 'Helfarve',
          colorCorrection: 'Farvekorrektion'
        },
        styling: {
          eventHairstyle: 'Styling til event',
          washMyHair: 'Hårvask',
          blowOut: 'Blowout (Føntørring)'
        },
        blonde: {
          airtouch: 'Airtouch',
          babylights: 'Babylights',
          totalBlonde: 'Total blonde',
          totalBlondeRoots: 'Total blonde bundfarve',
          balayage: 'Balayage / Brazilian blonde',
          contouring: 'Contouring / face framing highlights'
        },
        treatments: {
          wella: 'Wella',
          davines: 'Davines',
          nashi: 'Nashi',
          scalpDetox: 'Scalp detox'
        }
      },
      combined: {
        haircutTonerShort: 'Klipning + toner kort',
        haircutTonerLong: 'Klipning + toner langt',
        haircutColorShort: 'Klipning + helfarvning kort',
        haircutColorLong: 'Klipning + helfarvning langt',
        haircutTreatment: 'Klipning + enhver behandling',
        haircutTreatmentToner: 'Klipning + behandling + toner'
      },
      bookingCta: 'Klar til at Booke Din Tid?',
      contactUs: 'Kontakt Os'
    },
    // Contact
    contact: {
      title: 'Kom i Kontakt',
      subtitle: 'Jeg vil elske at høre fra dig. Kig forbi, eller kontakt mig når som helst.',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'Email',
      openingHours: 'Åbningstider',
      mapPlaceholder: 'Kort integration placeholder',
      bookNow: 'Book Nu',
      contactMe: 'Kontakt Mig'
    },
    // Footer
    footer: {
      myServices: 'Mine Services',
      quickLinks: 'Links',
      home: 'Hjem',
      about: 'Om Mig',
      prices: 'Priser',
      contact: 'Kontakt',
      bookAppointment: 'Book Tid',
      rights: 'Alle rettigheder forbeholdes'
    },
    // Days
    days: {
      monday: 'Mandag',
      tuesday: 'Tirsdag',
      wednesday: 'Onsdag',
      thursday: 'Torsdag',
      friday: 'Fredag',
      saturday: 'Lørdag',
      sunday: 'Søndag',
      closed: 'Lukket'
    },
    // About
    about: {
      title: 'Om Mig',
      subtitle: 'Passioneret frisør med fokus på dit drømmehår',
      content: 'Velkommen til min salon! Mit navn er Cristina Ungureanu, og jeg er stolt ejer og passioneret frisør med mere end syv års erfaring. Jeg tilbyder skræddersyede behandlinger som klip, farve og styling – altid med fokus på både sundt og smukt hår. Jeg udvikler mig løbende gennem kurser og masterclasses for at kunne tilbyde de nyeste trends og teknikker. Hos mig får du en varm og personlig oplevelse, hvor dine ønsker er i centrum. Book en tid i dag og lad os sammen skabe dit drømmehår!'
    }
  },
  en: {
    // Navbar
    nav: {
      home: 'Home',
      about: 'About Me',
      haircuts: 'Haircuts',
      coloring: 'Coloring',
      treatments: 'Treatments',
      prices: 'Prices',
      contact: 'Contact',
      bookNow: 'Book Now'
    },
    // Hero
    hero: {
      tagline: 'Where beautiful hair begins',
      description: 'With over seven years of professional experience, I aim to bring out your confidence and beauty. I specialize in tailored hair cuts, advanced coloring techniques, and high-end treatments. Every service I provide is customized to meet your specific needs.',
      bookNow: 'Book Now',
      contactUs: 'Contact Me'
    },
    // Services
    services: {
      title: 'My Services',
      subtitle: 'Discover my range of specialized hair services',
      haircuts: {
        title: 'Haircuts',
        subtitle: 'Tailored to perfection',
        description: 'Every haircut is customized to suit your face shape, hair texture, and personal style. Whether you are looking for a classic cut or something bold and contemporary, I will create a look that brings out your best features.',
        features: [
          'Consultation',
          'Precision cutting techniques',
          'Styling and finishing',
          'Personalized hair care recommendations'
        ]
      },
      coloring: {
        title: 'Hair Coloring',
        subtitle: 'Advanced techniques',
        description: 'Specializing in cutting-edge coloring methods that deliver stunning, natural-looking results. From subtle dimension to dramatic transformations, I use premium products to achieve the perfect shade.',
        servicesOffered: 'Color Services Offered',
        features: [
          'Airtouch',
          'Total Blond',
          'Babylights',
          'Brazilian Blonde',
          'Balayage',
          'All Over Color',
          'Color Correction'
        ]
      },
      treatments: {
        title: 'Hair Treatments',
        subtitle: 'Premium care',
        description: 'Restore and rejuvenate your hair with high-end treatments from world-renowned brands. Each treatment is selected specifically for your hair needs to deliver maximum results.',
        treatmentsOffered: 'Treatments Offered',
        features: [
          'Nashi Argan treatment',
          'Davines treatment',
          'Schwarzkopf professional system',
          'Deep conditioning',
          'Scalp detox treatment'
        ]
      },
      learnMore: 'Learn More',
      aboutService: 'About This Service',
      whatsIncluded: 'What is Included'
    },
    // Gallery
    gallery: {
      title: 'My Work',
      subtitle: 'Beautiful transformations and satisfied clients',
      colorTransformations: 'Color Transformations',
      haircutExamples: 'Haircut Examples'
    },
    // Why Choose
    whyChoose: {
      title: 'Why Choose Madame Cristina',
      experience: {
        title: 'Years Experience',
        description: 'Professional expertise you can trust'
      },
      trends: {
        title: 'Latest Trends',
        description: 'Continuously updated through masterclasses'
      },
      care: {
        title: 'Personalized Care',
        description: 'Every service customized to your needs'
      }
    },
    // CTA
    cta: {
      ready: 'Ready for Your Transformation?',
      book: 'Book your appointment today and experience the difference',
      bookAppointment: 'Book Your Appointment',
      readyForService: 'Ready to Experience',
      question: 'Have questions about my services or pricing? Feel free to contact me or book your appointment online.'
    },
    // Prices
    prices: {
      title: 'Price List',
      subtitle: 'Transparent pricing for all my services. All prices in DKK.',
      haircut: 'Women\'s Haircut',
      haircutNote: '(incl. wash and blow dry)',
      color: 'Color',
      colorNote: '(incl. wash and blow dry)',
      styling: 'Styling',
      stylingNote: '(incl. wash and blow dry)',
      blonde: 'Blonde',
      blondeNote: '(incl. wash and blow dry)',
      treatments: 'Treatments',
      treatmentsNote: '(incl. wash and blow dry)',
      popular: 'Popular',
      specialOffers: 'Special Offers',
      saveWith: 'Save with my combined appointment packages',
      note: '* Prices may vary depending on hair length, thickness, and condition. Final price will be confirmed during consultation.',
      items: {
        haircut: {
          short: 'Short',
          long: 'Long',
          curlCut: 'Curl cut',
          bangs: 'Bangs cut (without wash)'
        },
        color: {
          roots: 'Root color',
          toner: 'Toner',
          allOverColor: 'All over color',
          colorCorrection: 'Color correction'
        },
        styling: {
          eventHairstyle: 'Event styling',
          washMyHair: 'Hair wash',
          blowOut: 'Blowout (blow dry)'
        },
        blonde: {
          airtouch: 'Airtouch',
          babylights: 'Babylights',
          totalBlonde: 'Total blonde',
          totalBlondeRoots: 'Total blonde root color',
          balayage: 'Balayage / Brazilian blonde',
          contouring: 'Contouring / face framing highlights'
        },
        treatments: {
          wella: 'Wella',
          davines: 'Davines',
          nashi: 'Nashi',
          scalpDetox: 'Scalp detox'
        }
      },
      combined: {
        haircutTonerShort: 'Haircut + toner short',
        haircutTonerLong: 'Haircut + toner long',
        haircutColorShort: 'Haircut + all over color short',
        haircutColorLong: 'Haircut + all over color long',
        haircutTreatment: 'Haircut + any treatment',
        haircutTreatmentToner: 'Haircut + treatment + toner'
      },
      bookingCta: 'Ready to Book Your Appointment?',
      contactUs: 'Contact Us'
    },
    // Contact
    contact: {
      title: 'Get In Touch',
      subtitle: 'I would love to hear from you. Visit me or reach out anytime.',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      openingHours: 'Opening Hours',
      mapPlaceholder: 'Map integration placeholder',
      bookNow: 'Book Now',
      contactMe: 'Contact Me'
    },
    // Footer
    footer: {
      myServices: 'My Services',
      quickLinks: 'Quick Links',
      home: 'Home',
      about: 'About Me',
      prices: 'Prices',
      contact: 'Contact',
      bookAppointment: 'Book Appointment',
      rights: 'All rights reserved'
    },
    // Days
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      closed: 'Closed'
    },
    // About
    about: {
      title: 'About Me',
      subtitle: 'Passionate hairstylist focused on your dream hair',
      content: 'Welcome to my salon! My name is Cristina Ungureanu, and I am a proud owner and passionate hairstylist with more than seven years of experience. I offer tailored treatments such as cuts, color, and styling – always with a focus on both healthy and beautiful hair. I continuously develop myself through courses and masterclasses to be able to offer the latest trends and techniques. With me, you get a warm and personal experience where your wishes are at the center. Book an appointment today and let us create your dream hair together!'
    }
  }
};